import { createFileRoute } from '@tanstack/react-router'
import { RequirePermission } from '@/components/ui/require-permission'
import { CustomerPointPage } from '@/features/customer-points'

export const Route = createFileRoute('/_authenticated/billing/customer-points')(
  {
    component: () => (
      <RequirePermission permission='customer_points.read'>
        <CustomerPointPage />
      </RequirePermission>
    ),
  }
)
